import React from "react";
import Button from "../element/Buttons";

const ResourceCard = ({ title, imgSrc }) => (
  <div className="flex flex-wrap">
    <div className="img-wrap w-3/5">
      <img src={imgSrc} alt="" className="rounded-xl" />
    </div>
    <div className="text-caption w-2/5">
      <span className="text-blue-700 block font-semibold text-base mb-1">
        {title}
      </span>
      <Button className="font-semibold text-gray-600 text-xs flex gap-1 hover:text-gray-900 focus:text-gray-600">
        Button CTA{" "}
        <svg
          width="16"
          height="15"
          viewBox="0 0 13 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.167 4.5v-3m0 0h-3m3 0-4 4m-1.5-3h-1.1c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656c-.163.32-.163.74-.163 1.581v3.2c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.655c.32.164.74.164 1.58.164h3.2c.84 0 1.26 0 1.582-.164a1.5 1.5 0 0 0 .655-.655c.164-.32.164-.74.164-1.581V7"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
    </div>
  </div>
);

export default ResourceCard;
